import {useEffect, useState} from 'react';
import {useFetchPostData} from './useFetchData'
import {useQueryParams} from './useLocationData'
import categoryMapping from '../data/mapping/pages/categoryMapping';
import categoryMockData from '../data/category.json';

const useCategoryData = (pagePath) => {
  const queryKey = 'categoryData' + pagePath;
  const queryParams = useQueryParams();
  const isMockData = queryParams.get('useMockData') === 'true';
  const [categoryQueryData, setGlobalData] = useState('');
  const { isLoading, error, data } = useFetchPostData(queryKey, pagePath, isMockData);

  useEffect(() => {
      if (data && !isMockData) {
          const mappedData = categoryMapping(data);
          setGlobalData(mappedData);
      }
  }, [data, isMockData])

  if (isMockData) {
    return {
      error: false,
      isLoading: false,
      categoryQueryData: categoryMockData
    };
  }

  return  {
    error,
    isLoading,
    categoryQueryData
  };
}

export default useCategoryData;

